import { styled } from "styled-components";



const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const deviceMin = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const deviceMax = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};


export const CommonHeadFooter = styled.label`
        font-family: Inter;
        // font-size: 20px;
        font-weight: 500;
        line-height: 24.2px;
        text-align: center;
        margin-bottom: 1.313rem;
        width: 100%;

          @media ${deviceMin.laptop}{
    font-size: 20px;

  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      font-size: 16px;
  }
  `;

export const FooterHead = styled(CommonHeadFooter)`
  text-align: left;
  margin-bottom:13px;

  `

export const FooterText = styled.div`

    font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;


  `
export const MainFooter = styled.div`
  background: #1A2425;
  color: #F2F2F2;
  display:flex;

  @media ${deviceMin.laptop} {
    padding: 4.9rem;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    padding: 4.9rem;
  }

  @media ${deviceMax.tablet}{
	  padding: 2rem;
  }


  `
export const LogoStyle = styled.div`
    background: #F3F3F3;
    width: 93px;
    height: 89px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    top: 69px;
    left: 113px;
    gap: 0px;

  `;
export const LogoImgStyle = styled.img`
    width: 67.83px;
    height: 49.71px;
    opacity: 1; /* Ensure the image is visible */
  `;
export const Apple = styled.img`
  width: 24.34px;
  height: 30px;
  top: 3px;
  left: 5.8px;
  gap: 0px;
  opacity: 0px;

  `;

export const MaelanoImgStyle = styled.img`
    width: 182.47px;
  height: 27.04px;
  top: 174px;
  left: 68px;
  gap: 0px;
  opacity: 0px;

  margin-top:16px;

  `;

export const CopyRights = styled.div`
  background: #0F1617;
  height: 72px;
  top: 420px;
  left: 2px;
  gap: 0px;
  opacity: 0px;

    margin-top: -1px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

  `;


export const NewStyle = styled.div`
  font-family: Inter;
  font-size: 20px;
  line-height: 24.2px;
`;

export const CopyRightsText = styled(NewStyle)`
  font-weight: 500;
  text-align: left;
  color: #FFFFFF;

  @media ${deviceMin.laptop}{
    margin-right:68px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    margin-right:68px;
  }

  @media ${deviceMax.tablet}{
	  margin-right:15px;
    font-size: 15px;
  }
  `;

export const FooterButton = styled.button`
    width: 151px;
    height: 46px;
    border-radius: 40px;
    border: 1px solid #BDBDBD;
    background: none;
    opacity: 1; 
    cursor: pointer; 
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    color:white;

  `;
export const DownloadText = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 12.1px;
  text-align: left;
  color: #F3F3F3;
  `;
export const ApplePlayText = styled.span`
  color: #FFFFFF;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;

  `;

export const SocialDiv = styled.div`
  width: 221px;
  height: 42px;
  top: 337px;
  left: 68px;
  gap: 27px;
  opacity: 0px;
  display:flex;
  flex-direction:row;
  align-items: center;
  justify-content: space-between;
  `;

export const SocialFBImg = styled.img`
  width: 34px;
  height: 33.79px;
  opacity: 0px;
  color:#FFFFFF;

  `;

export const SocialInstaImg = styled.img`
  width: 30px;
  height: 30px;
  top: 3px;
  left: 3px;
  opacity: 0px;
  color:#FFFFFF;

  `;

export const SocialTwitterImg = styled.img`
  width: 31.31px;
  height: 32px;
  left: 0.34px;
  gap: 0px;
  opacity: 0px;

  color:#FFFFFF;

  `;

export const SocialPinImg = styled.img`
  width: 35px;
  height: 35px;
  top: 3.5px;
  left: 3.5px;
  gap: 0px;
  opacity: 0px;


  color:#FFFFFF;

  `;

// ==========================================
// ==========================================
// newsletter================================
// ==========================================
// ==========================================

export const NewsletterHead = styled.p`
  font-family: Inter;
  
  font-weight: 600;
  line-height: 48.41px;
  text-align: left;
  color: #FFFFFF;

  @media ${deviceMin.laptop}{
    font-size: 35px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 20px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	  font-size: 20px;
  }

  `;


export const NewsLetterStyle = styled.div`
  font-family: Inter;
 
  line-height: 29.05px;
  cursor: pointer;

  
  @media ${deviceMin.laptop}{
    font-size: 20px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	  font-size: 16px;
  }

  `;

export const NewsLetterText = styled(NewsLetterStyle)`
  font-weight:500;
  margin-top:10px;
  `;

export const NewsLetterP = styled(NewsLetterStyle)`
  font-weight:400;
  margin-top:20px;
  margin-bottom:21px;

  font-family: Inter;

font-weight: 500;
line-height: 29.05px;
text-align: left;


  @media ${deviceMin.laptop}{
    font-size: 20px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      font-size: 16px;
  }



  `;


export const NewsLetterBoxPadding = styled.div`
    
  @media ${deviceMin.laptop}{
    padding-left:87px;
    padding-right:87px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    padding-left:20px;
     padding-right:20px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      padding-left:20px;
         padding-right:20px;
  }

  `;

export const Rectangle = styled.img`
  width: 34px;
  height: 21px;
  top: 169px;
  left: 180px;
  gap: 0px;
  border-radius: 3px;
  border: 1px;
  opacity: 0px;
  margin-right:25px;

  `;


// ===========================================
// LOGIN PAGE ================================
// ===========================================

export const LoginHead = styled.div`
font-family: Inter;
font-size: 24px;
font-weight: 600;
line-height: 33.6px;
letter-spacing: -0.02em;
text-align: left;

  @media ${deviceMin.laptop}{
    font-size: 20px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      font-size: 14px;
  }

  `;

export const LoginBold = styled(NewStyle)`
font-family: Inter;
font-size: 20px;
font-weight: 400;
line-height: 19.6px;
letter-spacing: -0.02em;
text-align: left;

  @media ${deviceMin.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 14px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      font-size: 12px;
  }


  `;

export const LoginLogos = styled.img`
  width: 35px;
  height: 35px;
  top: 766px;
  left: 323px;
  gap: 0px;
  opacity: 0px;

  `;


export const ButtonText = styled(NewStyle)`

  font-weight: 600;
  color: #FFFFFF;

    @media ${deviceMin.laptop}{
    font-size: 20px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 18px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
	      font-size: 16px;
  }
  
  `;



// success page

export const SuccessHeadText = styled(NewStyle)`

  font-weight: 500;
  margin-bottom:4px;
  color:black;  

  `;
export const SuccessText = styled.div`

  font-family: Inter;
  font-size: 15px;
  font-weight: 500;
  line-height: 18.15px;
  color:#1A2425;

  `;


export const ButtonStyle = styled.button`
    color:white;
    border-radius: 20px; 
    background-color: #41B8E4; 
    height: 54vh;
    width: 100%;
    max-height: 60px; 
`;





// prduct listing



export const FilterH = styled(NewStyle)`
font-weight: 600;
margin: 10px 0;

@media ${deviceMin.laptop}{
  font-size: 20px;
}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
  font-size: 18px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
  font-size: 16px;
}
`;

export const FilterPeekItem = styled.div`

  font-weight: 400;
  line-height:21.78px;

  @media ${deviceMin.laptop}{
font-size: 18px;
}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 16px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 14px;
}
`;






export const ProductListingTitle = styled.div`
  background-color:#EC7426;
  color:white;
  width:124px; 
  height:32px; 
  padding:7px 14px;
  
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 18.15px;
  
  text-align:center;

`;

export const ProdCardName = styled.div`
font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 19.36px;
text-align: left;

 display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: 'ellipsis';

`;

export const ProdCardDesc = styled.div`
font-family: Inter;
font-size: 10px;
font-weight: 400;
line-height: 12.1px;
text-align: left;
margin-bottom:8px;

 display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: ellipsis;

`;

export const OriginalPrice = styled.div`
font-family: Inter;
font-size: 13px;
font-weight: 400;
line-height: 15.73px;

`;

export const RowProdTitle = styled.div`
font-family: Inter;
font-size: 36px;
font-weight: 500;
line-height: 43.57px;
text-align: left;

 display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: ellipsis;

   
  @media ${deviceMin.laptop}{
font-size: 20px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 18px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 16px;
}

`;

export const RowPriceOrange = styled.div`
font-family: Inter;

font-weight: 500;
line-height: 38.73px;
text-align: left;

color:#EC7426;

@media ${deviceMin.laptop}{
font-size: 25px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 20px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 18px;
}

`;

// 0313 3035500
export const RowPrice = styled.div` 
font-family: Inter;

font-weight: 500;
line-height: 29.05px;
text-align: left;

@media ${deviceMin.laptop}{
font-size: 18px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 14px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 12px;
}

`;


export const RowProdDet = styled.div`
    flex-grow: 1;
    flex-shrink: 2;
    flex-basis: auto;

    
    
     @media ${deviceMin.laptop}{
        padding:11px 0 0 20px;
     }

      @media ${deviceMin.tablet} and ${deviceMax.laptop}{
      padding:11px 0 0 15px;
      }

      @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
      padding:8px;
      }
    `;



export const RowStarReviews = styled(NewStyle)`

font-weight: 400;

  @media ${deviceMin.laptop}{
font-size: 18px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 16px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 14px;
}
`;

export const RowProdDesc = styled.div`



 display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: ellipsis;

   font-weight: 400;
   line-height:24.2px;

  @media ${deviceMin.laptop}{
font-size: 18px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 16px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 14px;
}
 `;

export const RowButton = styled.button`
      height: 47px;
      max-width: 159px;
      max-height: 47px;
      color: white;
       border-radius: 40px;
       border: 0;
       width: 20%;
       @media ${deviceMin.laptop}{
        font-size: 14px;
        }

        @media ${deviceMin.tablet} and ${deviceMax.laptop}{
        font-size: 12px;
        }

        @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
        font-size: 12px;
        }

   `;


export const PreFooterHead = styled.div`
font-family: Inter;

font-weight: 600;
line-height: 38.73px;

display:flex;
justify-content:center;

color:orange;

@media ${deviceMin.laptop}{
font-size: 25px;

}

@media ${deviceMin.tablet} and ${deviceMax.laptop}{
font-size: 20px;
}

@media ${deviceMin.mobileS} and ${deviceMax.tablet}{
font-size: 18px;
}

`;





// ==================================================
// ==================================================
// =============PRE FOOTER===========================
// ==================================================
// ==================================================

export const CategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem; /* Adjust the gap as needed */

  @media ${deviceMin.laptop} {
    /* Laptops and up: 5 items per row */
    > div {
      flex: 1 1 calc(20% - 1rem); /* Adjust for 5 items per row */
    }
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop} {
    /* Tablets: 3 items per row */
    > div {
      flex: 1 1 calc(33.33% - 1rem); /* Adjust for 3 items per row */
    }
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet} {
    /* Mobile: 2 items per row */
    > div {
      flex: 1 1 calc(50% - 1rem); /* Adjust for 2 items per row */
    }
  }
`;

export const CategorySection = styled.div`
  background: #f9f9f9; /* Example background color */
  padding: 1rem;
  border-radius: 5px; /* Example border radius */
  box-sizing: border-box;
  /* Flex properties are handled by CategoryContainer */
`;

export const CategoryList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const CategoryItem = styled.li`
  margin-bottom: 0.5rem; /* Adjust as needed */
`;


export const LiveProdName = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  line-height: 19.36px;


   display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: ellipsis;


`;


export const LiveOrgPrice = styled.div`
font-family: Inter;
font-size: 12px;
font-weight: 500;
line-height: 14.52px;
text-align: left;

`;
export const LiveNewPrice = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 500;
  line-height: 18.15px;
  text-align: left;

  color:#EC7426;

`;

export const LiveProdCard = styled.div`
    border-radius: 10px;
    max-width: 100%;
    width: 100%;
    max-height: 100%;
    height: auto;
    padding: 0.5rem;
    border: 1px solid #D9D9D9;
    
    &:hover {
      border: 1px solid #FBBD34;
  }
`;

export const LiveVisitStore = styled.button`
box-shadow: 0px 1px 2px 0px #1018280D;
// box-shadow: 5px 5px 0px 0px #1018280D;
border: 1px solid #1A2425;
background-color: #FFFFFF;
width: Hug (98px)px;
height: Fixed (28px)px;
padding: 8px 14px 8px 14px;
gap: 8px;
border-radius: 8px;
opacity: 0px;


font-family: Inter;
font-size: 14px;
font-weight: 500;
line-height: 20px;
text-align: left;


`;

export const LiveWatch = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    padding: 8px 0px 8px 0px;
    
    `;


export const ClearFilter = styled.button`
    height: 47px;
    max-width: 159px;
    max-height: 47px;
    color: white;
     border-radius: 40px;
     border: 0;
     width: 20%;
     @media ${deviceMin.laptop}{
      font-size: 14px;
      }

      @media ${deviceMin.tablet} and ${deviceMax.laptop}{
      font-size: 12px;
      }

      @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
      font-size: 12px;
      }

 `;


export const DetTitle = styled.div`
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 36.31px;
  text-align: left;
  padding: 1rem;
  white-space: nowrap;

  // @media ${deviceMin.laptop}{
  //  font-size: 24px;
  //  }

  @media ${deviceMin.tablet} and (max-width: 1199px){
    font-size: 18px;
  }

  @media ${deviceMax.tablet}{
    font-size: 16px;
  }
`;

export const DetProdTitle = styled.span`
  font-family: Inter;
  font-size: 30px;
  font-weight: 600;
  line-height: 43.57px;
  text-align: left;
  border-bottom:3px solid #f2f2f2;

  @media (max-width: 1199px){
    font-size: 30px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 26px;
  }

  @media ${deviceMax.tablet}{
    font-size: 22px;
  }

`;

export const DetProdItem = styled.span`
font-family: Inter;
font-weight: 400;
line-height: 29.05px;
text-align: left;

@media ${deviceMin.laptop}{
 font-size: 18px;
 }

 @media ${deviceMin.tablet} and ${deviceMax.laptop}{
 font-size: 14px;
 }

 @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
 font-size: 12px;
 }

`;

export const DetCouponApply = styled.button`
    width: 55px;
    border: none;
    height: 24px;
    background-color: orange;
    border-radius: 20px;
    color: white;
`;

export const MeasureSize = styled.div`
font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 19.36px;
text-align: justify;

`;

export const AuthPlayAppleButton = styled.button`
    width: 133.26px;
height: 38.26px;
top: 0.87px;
left: 0.87px;
gap: 0px;
opacity: 0px;

    border-radius: 10px;
    border: 1px solid #BDBDBD;
    background-color: #000;
    opacity: 1; 
    cursor: pointer; 
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    color:white;

  `;


export const UserHead = styled(NewsLetterStyle)`
    font-weight:700;
    display:flex;
    justify-content:center;
    color:#EC7426;
  `;



export const UserPicUpdate = styled.button`
  height: 47px;
  max-width: 93px;
  max-height: 38px;
  color: #1A2425;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
  //  width: 20%;
   background:none;
   @media ${deviceMin.laptop}{
    font-size: 14px;
    }

    @media ${deviceMin.tablet} and ${deviceMax.laptop}{
    font-size: 12px;
    }

    @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
    font-size: 12px;
    }

`;

export const DesDeliver = styled.div`
font-family: Inter;
font-size: 14px;
font-weight: 500;
line-height: 18.15px;
text-align: left;
`;
export const DesDeliverText = styled.div`
font-family: Inter;
font-size: 12px;
font-weight: 400;
line-height: 14.52px;
text-align: left;

`;


export const DescSold = styled.div`
font-family: Inter;
font-size: 10px;
font-weight: 500;
line-height: 12.1px;
text-align: left;

`;
export const DescRating = styled.div`
font-family: Inter;
font-size: 9px;
font-weight: 500;
line-height: 10.89px;
text-align: center;

`;

export const DescVisitStore = styled.button`

width: 99px;
height: 27px;
top: 741px;
left: 1156px;
gap: 0px;
border-radius: 5px;
border:none;
opacity: 0px;
background: #FBBD34;
color:white;



font-family: Inter;
font-size: 15px;
font-weight: 500;
line-height: 18.15px;
text-align: center;

display: flex;
    justify-content: center;
    align-items: center;


`;

export const SideBarWidth = styled.div`
  @media ${deviceMin.laptop} {
    width: 249px;
  }

  @media ${deviceMin.tablet} and ${deviceMax.laptop} {
    width: 249px;
  }

  @media ${deviceMin.mobileS} and ${deviceMax.tablet} {
	  width: 249px;
  }
`;

export const CardButtons = styled(LiveOrgPrice)`

    font-weight:400;
    color:#EC7426;
    `;


export const OrderActionButton = styled.button`
    height: 35px;
    max-width: 110px;
    max-height: 35px;
    color: white;
     border-radius: 40px;
     border: 0;
     width: 20%;
     
     @media ${deviceMin.laptop}{
      font-size: 14px;
      }

      @media ${deviceMin.tablet} and ${deviceMax.laptop}{
      font-size: 12px;
      }

      @media ${deviceMin.mobileS} and ${deviceMax.tablet}{
      font-size: 12px;
      }

 `;

export const OrderPara = styled.div`
font-family: Inter;
font-size: 11px;
font-weight: 400;
line-height: 13.31px;
text-align: left;

   display: -webkit-box;
  -webkit-line-clamp: 12
  -webkit-box-orient: vertical;  
  overflow: hidden;
   textOverflow: ellipsis;
`;

export const OrdersButton = styled.button`
font-family: Inter;
font-size: 12px;
font-weight: 400;
line-height: 14.52px;

text-align: center;

background-color:transparent;
max-width: 100%;
                    width: 150px;
                    border: 1px solid black;
                    border-radius: 20px;
                    height:30px;

`;